import { cn } from '@/lib/utils';

type ConnectionStatusProps = {
  isConnected: boolean;
  sessionId: string | null;
};

export function ConnectionStatus({ isConnected, sessionId }: ConnectionStatusProps) {
  if (!sessionId) {
    return (
      <div className="flex items-center gap-2 text-xs">
        <span className="text-muted-foreground">No session</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 text-xs">
      <span
        className={cn(
          'inline-block size-2 rounded-full',
          isConnected ? 'bg-green-500' : 'bg-red-500'
        )}
      />
      <span className={isConnected ? 'text-green-600' : 'text-red-600'}>
        {isConnected ? 'Connected' : 'Disconnected'}
      </span>
    </div>
  );
}
